<template>
  <div id="app">
    <hybhead title="首页" ></hybhead>
    <div class="page-div"></div>

    <div class="banner">
      <div class="banner-title-k"></div>
      <div class="banner-title">一个伪装成其他软件的聊天APP</div>
      <div class="banner-text">首次下载后，输入“0000”激活APP</div>
      <div class="banner-img">
        <!-- <swiper ref="mySwiper">
          <swiper-slide>
            <img src="../assets/img/index-banner-1.png" alt srcset />
          </swiper-slide>
          <swiper-slide>
            <img src="../assets/img/index-banner-2.png" alt srcset />
          </swiper-slide>
          <swiper-slide>
            <img src="../assets/img/index-banner-3.png" alt srcset />
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper> -->
        <indexBanner></indexBanner>
      </div>
    </div>
    <div class="content">多种伪装外壳</div>

    <div class="content-desc">手机里安装这些APP，完全看不出来是聊天APP哦~ 不同类型的APP之间可以正常交流，毫无障碍</div>

    <div class="app-info">
        <div class="app-info-utils">
              <div class="app-info-utils-img-div">
                <img src="../assets/img/app-info-utils.png" alt="" srcset="">
              </div>
              <p>工具类</p>
              <span>伪装成计算器、闹钟等工具 <br/>人畜无害的工具<br/> 但消息通知过于频繁，可能引起怀疑</span>
        </div>
         <div class="app-info-utils">
              <div class="app-info-utils-img-div">
                <img src="../assets/img/app-info-news.png" alt="" srcset="">
              </div>
              <p>新闻类</p>
              <span>伪装成新闻、头条等工具 <br/>收到聊天消息时提示新闻热点<br/>智能伪装，毫无破绽</span>
        </div>
    </div>
     <div class="app-info">
        <div class="app-info-utils">
              <div class="app-info-utils-img-div">
                <img src="../assets/img/app-info-xuexi.png" alt="" srcset="">
              </div>
              <p>学习类</p>
              <span>伪装成学英语、学韩语等工具<br/>学习聊天秒切换<br/>展示积极向上的人设</span>
        </div>
         <div class="app-info-utils">
              <div class="app-info-utils-img-div">
                <img src="../assets/img/app-info-youxi.png" alt="" srcset="">
              </div>
              <p>游戏类</p>
              <span>伪装成类似连连看等游戏APP<br/> 防查岗，安全保险 <br/>聊天时遇突发情况，秒切换至游戏页面</span>
        </div>
    </div>

    <div class="content">强大的伪装功能</div>

    <div class="content-desc">智能伪装设置，保护隐私安全，防止信息泄露</div>

    <div v-for="imginfo in imglist"  :key="imginfo">     
      <div class="app-info-g-list" >
          <img :src="imginfo.url" alt="">
      </div>
      <div class="app-info-g-list-border" >
      </div>
    </div>

     <div class="news-info-title">
       <img src="/static/img/news_title@2x.png" alt="" srcset="">
     </div>

     <div id="newsID" class="app-info-news-list">
         <div class="app-info-news-list-child" v-for="newsinfo in newsList" :key="newsinfo">
           <!--div class="app-info-news-list-imagediv" >
             <img :src="newsinfo.image" alt="" srcset="">
           </div-->
           <span>
             <a :href="newsinfo.aurl">{{newsinfo.title}}</a>
             <br><br>
             <span >{{newsinfo.time}}</span>
           </span>
        </div>
    </div>
    <div class="app-info-g-list-border"></div>

    <div class="news-info-friendlink">
      <div class="news-info-friendlink-imgchild"><img src="/static/img/friend@2x.png"></div>
      <div class="news-info-friendlink-child"><span>友链</span></div>
      <div class="news-info-friendlink-child2" ><a v-bind:href="friendUrl">{{friendName}}</a></div>
    </div>
    <hybfoot></hybfoot>
  </div>
</template>
<script>
import Axios from "axios";
import hybhead from "../views/common/head";
import hybfoot from "../views/common/foot";
import indexBanner from "../views/common/indexBanner";


export default {
  metaInfo: {
    title: "好运吧-首页"
  },
  name: "app",
  data() {
    return {
      msg: "注册协议Index",
      swiperOption: {
        autoplay: true, // 自动切换
        loop: true, // 循环
        pagination: {
          el: ".swiper-pagination"
        }
      },
      imglist:[
          {'url':'/static/img/app-info-g-1.png'},
          {'url':'/static/img/app-info-g-2.png'},
          {'url':'/static/img/app-info-g-3.png'},
          {'url':'/static/img/app-info-g-4.png'},

      ],
      friendName:"",
      friendUrl:"",
      newsList:[],
      friendsList:[]
    };
   
    
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper;
    }
  },

  mounted() {
    var cid = this.getQueryVariable('cid');
    console.log('cid:'+cid);
    if (cid) {
				localStorage.setItem('cid', cid)
			}
    this.getNewsList();
    this.getFriendsList();
  },
  methods:{
    getNewsList(){
      var api = "https://www.haoyunba.com/api/Api/loadindexnews?counts=6";
      var that=this;
      Axios.get(api)
              .then(function (response) {
                // handle success
                console.log(response);
                //this.list = response.data.result;
                console.log("data array is :"+response.data.data.length);
                if(response.data.data.length>0){
                  /*
                  console.log(response.data.data);
                  console.log(response.data.data[0].title);
                  console.log(response.data.data[0].time);
                  console.log(response.data.data[0].image);
                  console.log(response.data.data[0].description);
                  https://www.haoyunba.com/+response.data.data[0].aurl
                  */
                 that.newsList=response.data.data;
                 for(var i=0;i<that.newsList.length;i++){
                   that.newsList[i].aurl="https://www.haoyunba.com"+that.newsList[i].aurl;
                   that.newsList[i].image="https://www.haoyunba.com"+that.newsList[i].image;
                   var createTime = new Date(that.newsList[i].time*1000);
                   //console.log(createTime);
                   that.newsList[i].time=that.formatTm(createTime);
                   //that.newsList[i].time=createTime;
                   //console.log(that.formatTm(createTime));
                  
                   
                 }
                 console.log(that.newsList[0]);
                 //console.log(that.newsList[0].description);
                }

              })
              .catch(function (error) {
                // handle error
                console.log(error);
              })
              .then(function () {
                // always executed
              });      

    },
    getFriendsList(){
      var api = "https://www.haoyunba.com/api/Api/loadflinks?counts=6";
      var that=this;
      Axios.get(api)
              .then(function (response) {
                // handle success
                console.log(response);
                //this.list = response.data.result;
                console.log("friends array is :"+response.data.data.length);
                if(response.data.data.length>0){
                 
                 that.friendsList=response.data.data;
                 that.friendName=that.friendsList[0].linkname;
                 that.friendUrl=that.friendsList[0].linkurl;
                 
                 console.log(that.friendsList[0]);
                 
                }

              })
              .catch(function (error) {
                // handle error
                console.log(error);
              })
              .then(function () {
                // always executed
              });      

    },
    getQueryVariable(field) {
      var url = window.location.href,
      param = {},
      splitArray = url.split("?"),
      searchLocation = splitArray.length <= 1 ? "" : splitArray[1].split("#")[0],
      searchParams = searchLocation.split("&"),
      value,
      key;
      for (var i = 0, leni = searchParams.length; i < leni; i++) {
        key = searchParams[i].split("=")[0];
        value = searchParams[i].split("=")[1];
        if (!key) {
          continue;
        }
      param[key] = value;
      }

    // 路由跳转时url参数会被覆盖,所以仅在首次进入时读取
    return field ? param[field] : param;
  
    
    },

  
   padLeftZero(str) {
      return ('00' + str).substr(str.length);
   },

   formatTm: function (dateTem) {
    let year = dateTem.getFullYear();
    let month = dateTem.getMonth() + 1;
    let day = dateTem.getDate();
    let hour = dateTem.getHours();
    let minute = dateTem.getMinutes();
    let second = dateTem.getSeconds();

    month = (month < 10 ? "0" : "") + month;
    day = (day < 10 ? "0" : "") + day;
    hour = (hour < 10 ? "0" : "") + hour;
    minute = (minute < 10 ? "0" : "") + minute;
    second = (second < 10 ? "0" : "") + second;

    return year + '-' + month + '-' + day ;
   }

  },
  components: {
    hybhead,hybfoot,indexBanner
  }
};
</script>
<style  scoped>
.banner {
  width: 750px;
  height: 811px;
  background: linear-gradient(90deg, #8a4cff 0%, #4668ff 100%);
}
.page-div{
  width: 100%;
  height: 100px;
} 
.banner-title-k {
  width: 750px;
  height: 100px;
}
.banner-title {
  width: 750px;
  height: 46px;
  font-size: 48px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #ffffff;
  line-height: 27px;
  margin: 0 auto 0 auto;
  text-align: center;
}
.banner-text {
  width: 750px;
  height: 25px;
  font-size: 24px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #ffffff;
  line-height: 20px;
  text-align: center;
  margin: 19px auto 0 auto;
}
.banner-img {
  width: 230px;
  height: 465px;
  margin: 64px auto 0 auto;
}
.banner-img img {
  width: 100%;
  height: 100%;
}



.content {
  width: 100%;
  margin: 99px auto 0 auto;
  font-size: 40px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #343434;
  line-height: 27px;
}
.content-desc {
  margin: 20px auto 0 auto;
  width: 551px;
  height: 52px;
  font-size: 24px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #666666;
  line-height: 28px;
}
.app-info{
  width: 95%;
  height: auto;
  display: flex;
  margin: 60px auto 20px auto;
}

.app-info-utils,.app-info-news{
  flex: 1;
  align-items: center;
  justify-content: center;


}
.app-info-utils-img-div
{
  align-items: center;
  justify-content: center;
  width: 120px;
  height: 120px;
  text-align: center;
  margin: 0 auto;
}

.app-info-utils-img-div img{
  width: 100%;
  height: 100%;
}

.app-info-utils p{
  
font-size: 28px;
font-family: PingFang SC;
font-weight: 500;
color: #343434;
line-height: 22px;
}
.app-info-utils span{
 
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 26px;

}
.app-info-news-list{
  flex: 1;
  align-items: center;
  justify-content: left;
  width: 700px;
  padding-left: 5%;
  padding-top: 10px;
  padding-bottom: 30px;

}
.app-info-news-list-child{
  flex: 1;
  align-items: center;
  justify-content: left;
  width: 700px;
  height: 100px;
  padding-top: 10px;

}
.app-info-news-list-imagediv
{
  width: 80px;
  height: 80px;
  float: left;
}
.app-info-news-list-imagediv img{

  width: 100%;
  height: 100%;
  float: left;
  
}
.app-info-news-list a{

font-size: 28px;
font-family: PingFang SC;
font-weight: 500;
color: #343434;
line-height: 22px;
}
.app-info-news-list span{

font-size: 18px;
font-family: PingFang SC;
font-weight: 500;
color: #9b9797;
line-height: 22px;
float: left;
padding-left: 10px;
}


.app-info-g-list{
  width: 100%;
  height: 424px;
  margin: 70px auto 70px auto;
}

.app-info-g-list img{
  width: 100%;
  height: 100%;
}
.app-info-g-list-border{
  width: 690px;
  height: 1px;
  background: #EEEEEE;
  margin: 0 auto;
}

.news-info-friendlink{
  flex: 1;
  align-items: center;
  justify-content: left;
  width: 700px;
  height: 50;
  padding-left: 5%;
  padding-top: 10px;
  padding-bottom: 20px;
  float:center;
  display: inline-table;
  vertical-align: middle;
  margin: 0 auto;
}

.news-info-friendlink a{

  font-size: 24px;
  font-family: PingFang SC;
  font-weight: 500;
  padding-left: 10px;
  color: #2640d4;
  text-decoration-line: none;
  float: left;
  text-align: bottom;

}

.news-info-friendlink span{

font-size: 32px;
font-family: PingFang SC;
font-weight: 500;
color: #343434;
line-height: 32px;

}
.news-info-friendlink-child{
  flex: 1;
  width: 80px;
  height: 40px;
  float: center;
  display: inline-table;
}


.news-info-friendlink-imgchild{
  float: center;
  width: 40px;
  height: 40px;
  display: inline-table;
}

.news-info-friendlink-imgchild img{

  width: 100%;
  height: 100%;
  vertical-align: middle;
}

.news-info-friendlink-child2{
  flex: 1;
  width: 200px;
  height: 40px;
  float: center;
  display: inline-table;
  vertical-align: middle;
  margin: 0 auto;
}
.news-info-title{
  padding-top: 40px;
  padding-bottom: 20px;
  align-items: center;
  justify-content: center;
  width: 250px;
  height: 50px;
  text-align: center;
  margin: 0 auto;
  
}

.news-info-title img{
  width: 100%;
  height: 100%;
}
</style>


// WEBPACK FOOTER //
// src/views/index.vue